import { e as estimateDistanceFromLatLngInMiles, a as getDistanceSortedStores, O as OUT_OF_AREA_THRESHOLD } from './built-utilities-e07c7454.js';
import { f as fetchStores } from './built-fetch-stores-17ca97d2.js';
import { g as getCurrentLocation } from './built-index-750f2ec8.js';

// @ts-check
/**
 * Fetches a list of stores, with accompanying data (address, hours, etc)
 *
 * @returns {Promise<Object[]>} A collection of Decathlon store objects
 */

const fetchStoreList = async () => {
  const stores = await fetchStores();
  return stores.map(store => Object.assign({}, store, {
    distance: '',
    distanceFloat: ''
  }));
};
/**
 * Fetches the user's approximate location based on their IP address
 *
 * @returns {Promise<UserLocationData|null>} User's location information or null
 * if it can't be obtained
 */

const fetchUserLocationData = async () => {
  const userLocationData = await getCurrentLocation();
  if (!userLocationData) return null;
  const {
    zip_code: zipcode,
    city,
    region_code: stateCode,
    latitude,
    longitude
  } = userLocationData;
  return {
    zipcode,
    city,
    stateCode,
    latitude,
    longitude
  };
};
/**
 * Calculate the distance between a user's location and store locations
 *
 * @param {Object} data The user's location and Decathlon stores
 * @param {UserLocationData} data.origin User's location
 * @param {import('../../store').Store[]} data.stores A collection of store locations
 *
 * @returns {Array} The distance calculation for each store
 */

const getDistanceData = ({
  origin,
  stores
}) => {
  const distances = stores.map(store => {
    const distance = estimateDistanceFromLatLngInMiles({
      lat1: store.lat,
      lon1: store.lng,
      lat2: origin.latitude,
      lon2: origin.longitude
    });
    return distance + " mi";
  });
  return distances;
};

// @ts-check
/**
 * Fetch stores and calculate the distance between origin and store locations.
 * Sort stores ordering, filtering stores outside of acceptable threshold.
 *
 * @param {import('./api').UserLocationData} origin The user's location via IP address
 *
 * @returns {Promise<Store[]>} The arranged list of stores available in respect of distance and threshold
 */

const getAvailablePickupStores = async origin => {
  try {
    let storeList = []; // Get store objects

    const stores = await fetchStoreList(); // Calculate the distance from the user's origin to the store(s)

    const distances = getDistanceData({
      origin,
      stores
    }); // Adds the distance values to each store's object data

    if (distances.length > 0) {
      storeList = getDistanceSortedStores({
        stores,
        distances,
        threshold: OUT_OF_AREA_THRESHOLD
      });
    } // Return the list of stores


    return storeList;
  } catch (error) {
    console.error('Error thrown in fulfillment store fetch and distance calculation:', error);
    throw error;
  }
};

export { fetchUserLocationData as f, getAvailablePickupStores as g };
